import styled from "styled-components"
import { useState } from "react"
import TopMenus from "../../shared/TopMenus"
import UpdateBlogMainSide from "./main/UpdateBlogMainSide"
import { useDispatch } from "react-redux"
import UpdateFAQContentController from "./faq/UpdateFAQContentController"
import UpdateBlogContentController from "./content/UpdateBlogContentController"


const Container = styled.div`
    height: 100%;
    width: 100%;
    
`

const menuData = [
    {
      id:0,
      text:"Ana Bölüm"
    },
    {
      id:1,
      text:"Blog İçerik"
    },
    {
      id:2,
      text:"Sıkça Sorulan Sorular"
    }
  ]

const UpdateBlogMenus = () => {
    const dispatch = useDispatch()
    const [activeMenuId, setActiveMenuId] = useState(0)

  return (

    <Container>
        <TopMenus menuList={menuData} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />

        {activeMenuId === 0 && <UpdateBlogMainSide />}
        {activeMenuId === 1 && <UpdateBlogContentController />}
        {activeMenuId === 2 && <UpdateFAQContentController />}
    </Container>
  )
}

export default UpdateBlogMenus